import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@/components/ThemeProvider";
import { ConsentProvider } from "@/contexts/ConsentContext";
import { DebugProvider } from "@/contexts/DebugContext";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
    <ConsentProvider>
      <DebugProvider>
        <App />
      </DebugProvider>
    </ConsentProvider>
  </ThemeProvider>
);
